<template>
  <footer class="footer">
    <div class="max-w-6xl mx-auto px-6 py-10">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
        <div class="text-center md:text-left">
          <img src="../assets/logo-branco.png" alt="Prefeitura de Duque de Caxias" width="180" class="mx-auto md:mx-0" />
        </div>

        <div class="text-center">
          <p class="text-white text-sm font-bold uppercase tracking-wider mb-3">Links</p>
          <div class="flex flex-col gap-2">
            <a href="https://duquedecaxias.rj.gov.br/" target="_blank" class="footer-link">Portal da Prefeitura</a>
            <a href="https://saude.duquedecaxias.rj.gov.br/" target="_blank" class="footer-link">Portal da Saúde</a>
            <a href="https://transparencia.duquedecaxias.rj.gov.br/" target="_blank" class="footer-link">Portal da Transparência</a>
          </div>
        </div>

        <div class="text-center md:text-right">
          <p class="text-white text-sm opacity-50">Desenvolvido pela</p>
          <p class="text-white text-sm font-bold">Subsecretaria de Tecnologia</p>
        </div>
      </div>

      <hr class="border-white border-opacity-10 my-6" />

      <p class="text-center text-white text-sm opacity-50">
        &copy; Prefeitura Municipal de Duque de Caxias, 2026
      </p>
    </div>
  </footer>
</template>

<script>
export default { name: "Footer" };
</script>

<style scoped>
.footer {
  background: #195493;
  border-top: 3px solid #E8652D;
}
.footer-link {
  color: rgba(255,255,255,0.7);
  font-size: 0.875rem;
  transition: color 0.3s;
}
.footer-link:hover { color: #E8652D; }
</style>
